import React from 'react';
import {
  ToggleLeft,
  NumberNine,
  ListBullets,
  TextT,
  PencilSimple,
} from '@phosphor-icons/react';
import { cn } from 'src/utils/className';
import {
  PostCallAnalysisItem,
  PostCallAnalysisItemType,
} from 'src/interfaces/agent.interface';

type PostCallDataExtractionCardProps = {
  item: PostCallAnalysisItem;
  onClick: () => void;
  disabled?: boolean;
};

const iconByType: Record<PostCallAnalysisItemType, React.ReactNode> = {
  [PostCallAnalysisItemType.BOOLEAN]: (
    <ToggleLeft className="w-4 h-4" weight="fill" />
  ),
  [PostCallAnalysisItemType.NUMBER]: (
    <NumberNine className="w-4 h-4" weight="fill" />
  ),
  [PostCallAnalysisItemType.ENUM]: (
    <ListBullets className="w-4 h-4" weight="fill" />
  ),
  [PostCallAnalysisItemType.STRING]: (
    <TextT className="w-4 h-4" weight="fill" />
  ),
};

export const PostCallDataExtractionCard: React.FC<
  PostCallDataExtractionCardProps
> = ({ item, onClick, disabled = false }) => {
  return (
    <div
      data-testid={`card-data-extraction-${item.id}`}
      onClick={disabled ? undefined : onClick}
      className={cn(
        'px-4 py-3 rounded-lg border border-neutral-200 bg-neutral-0',
        'transition-all duration-150',
        disabled
          ? 'opacity-60 cursor-not-allowed'
          : 'cursor-pointer hover:border-neutral-300 hover:shadow-sm',
      )}
    >
      <div className="flex items-center gap-3">
        <div className={cn('p-2 rounded', 'bg-primary-100 text-primary-500')}>
          {iconByType[item.type]}
        </div>
        <div className="flex-1 min-w-0 flex items-center gap-4">
          <div className="flex items-center gap-2 min-w-0 shrink-0">
            <h3
              data-testid={`text-data-extraction-label-${item.id}`}
              className="text-body font-medium text-primary-body truncate"
            >
              {item.label || item.id}
            </h3>
          </div>
          <div className="flex items-center gap-3 text-description text-neutral-400 truncate">
            <span className="truncate">{item.id}</span>
          </div>
        </div>
        <div className="text-neutral-400">
          <PencilSimple size={20} />
        </div>
      </div>
    </div>
  );
};
